import { faTableLayout } from '@fortawesome/pro-regular-svg-icons';
import _sortBy from 'lodash.sortby';
import type { RouteProps } from './themesRoutes';

export const blocksRoutes = [
  {
    title: 'Overview',
    pages: [{ title: 'Mobile', slug: 'themes/blocks/overview/mobile' }],
    icon: faTableLayout,
  },
  {
    title: 'Pages',
    pages: [
      { title: 'Table', slug: 'themes/blocks/pages/table' },
      { title: 'Pipeline snapshot', slug: 'themes/blocks/pages/pipeline-snapshot' },
      { title: 'Squad reviewer', slug: 'themes/blocks/pages/squad-reviewer' },
      { title: 'Sign in', slug: 'themes/blocks/pages/sign-in' },
      // { title: 'Project priority', slug: 'themes/blocks/pages/project-priority' },
    ],
    icon: faTableLayout,
  },
  {
    title: 'Empty states',
    pages: [
      { title: 'Error', slug: 'themes/blocks/empty-states/error' },
      { title: 'No content', slug: 'themes/blocks/empty-states/no-content' },
    ],
    icon: faTableLayout,
  },
];

export const allBlocksRoutes = blocksRoutes.reduce((acc, curr: RouteProps) => {
  return [...acc, ...curr.pages];
}, []);
